module.exports = __webpack_public_path__ + "img/naturaleza.4fe13faa.svg";